import React from 'react';
import './Logo.css';

interface LogoProps {
	onClick: () => void;
}

const Logo: React.FC<LogoProps> = ({ onClick }) => {
	return (
		<div className="logo shadow">
			<div className="logo-text">
				<button type="button" className="logo-button" onClick={onClick}>
					PetroFluid
				</button>
			</div>
		</div>
	);
};

export default Logo;